module.exports = __webpack_public_path__ + "assets/img/u5.429f80e8.png";